import { Component } from '@angular/core';
import { Field } from '@ngx-formly/core';

@Component({
	selector: 'formly-field-html',
	template: `
		<div [innerHTML]="to['content']"></div>
	`,
})
export class FormlyFieldHtml extends Field {
}



// WEBPACK FOOTER //
// /Users/sofia/Documents/ng2-portals/ng2-firebase-toolkit-admin/src/app/common/formly/types/html.ts